import { CvValue, FieldMetadataAccount } from '@/models'
import ApiClient from '@/services/api-client'
import { CvValueUtils } from '@/utils/cv-value-utils'

export const FMAT_SELECT = 'fmat-sel'
export const FMAT_BOOL = 'fmat-bool'

export type AccountMetadata = {
  fields: FieldMetadataAccount[];
  selectOptions: Record<string, CvValue[]>;
}

/**
 * Loads a company's account metadata fields (ordered by displayOrder) together with the option
 * values for every select field. Select options go through CvValueUtils so they are cached across
 * mounts and the "indefinido" (shortCode 'indef') value is filtered out.
 * Any request error is propagated so the caller can surface its own error state.
 */
export async function loadAccountMetadata(companyId: string): Promise<AccountMetadata> {
  if (!companyId) {
    return { fields: [], selectOptions: {} }
  }

  const fields = (await ApiClient.getFieldMetadataByCompany(companyId))
    .slice()
    .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))

  const optionTypeIds = Array.from(new Set(
    fields
      .filter(field => field.typeId === FMAT_SELECT && field.optionsId)
      .map(field => field.optionsId as string)
  ))

  const selectOptions: Record<string, CvValue[]> = {}
  for (const typeId of optionTypeIds) {
    selectOptions[typeId] = await CvValueUtils.getCvValuesByType(typeId)
  }

  return { fields, selectOptions }
}
